import { useQueryClient } from '@tanstack/react-query';

import Reactions from 'hb-react/frontoffice/components/Reactions';
import { useTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';
import type { Likes } from 'hb-react/shared/apps/Events/types';
import toggleLike from 'hb-react/shared/components/DesignSystem/Reactions/utils/toggleLike';

interface CommentsContainerProps {
  eventId: number;
  likes: Likes;
}

export const CommentsContainer = ({
  eventId,
  likes,
}: CommentsContainerProps) => {
  const topicContext = useTopicContext();
  const queryClient = useQueryClient();

  const onLikeCallback = () => {
    queryClient.removeQueries({
      queryKey: ['event', eventId.toString(), topicContext.topicId],
    });
  };

  return (
    // @ts-expect-error untyped component
    <Reactions
      key={`NetworkEvents::Event:${eventId}`}
      displayCommentsByDefault
      id={eventId}
      initialLikes={likes}
      onTogglePostLike={toggleLike}
      railsType="NetworkEvents::Event"
      type="NetworkEvents::Event"
      onLikeCallback={onLikeCallback}
    />
  );
};
